/* ============================================================
   CUBIE TRACKING ENGINE - Lightweight Version (ASCII Only)
============================================================ */

window.CubieTrack = {
  /* -----------------------------
     SETTINGS
  ------------------------------ */
  debug: true, // Debug ON

  /* -----------------------------
     MODULE PIPELINE
  ------------------------------ */
  pipeline: [
    "bindClicks",
    "bindScrolls",
    "bindImpressions"
  ],

  /* -----------------------------
     INITIALIZER
  ------------------------------ */
  init() {
    this.log("Initializing CubieTrack...");
    this.pipeline.forEach(method => {
      if (typeof this[method] === "function") {
        this.log("Running module: " + method);
        this[method]();
      } else {
        this.log("Missing module: " + method);
      }
    });
  },

  /* -----------------------------
     DEBUG LOGGER
  ------------------------------ */
  log(...args) {
    if (this.debug) {
      console.log("[CubieTrack]", ...args);
    }
  },

  /* -----------------------------
     GA4 WRAPPER
  ------------------------------ */
  send(params) {
    if (!window.gtag) {
      this.log("gtag not found - event skipped:", params);
      return;
    }

    const { action, category, label, extra } = params;

    this.log("Sending GA4 event:", { action, category, label, extra });

    gtag("event", action, {
      event_category: category || "",
      event_label: label || "",
      ...(extra || {})
    });
  },

  /* -----------------------------
     CLICK TRACKING
  ------------------------------ */
  bindClicks() {
    this.log("Binding click tracking...");

    document.querySelectorAll("[data-track]").forEach(el => {
      if (el._cubieClickBound) return;
      el._cubieClickBound = true;

      el.addEventListener("click", () => {
        const params = this.parse(el);
        if (!params) return;

        if (["scroll", "impression"].includes(params.action)) return;

        this.log("Click event:", params);
        this.send(params);
      });
    });
  },

  /* -----------------------------
     LIGHTWEIGHT SCROLL TRACKING
  ------------------------------ */
  bindScrolls() {
    this.log("Binding lightweight scroll tracking...");

    document.querySelectorAll("[data-track]").forEach(el => {
      const params = this.parse(el);
      if (!params || params.action !== "scroll") return;
      if (el._cubieScrollBound) return;
      el._cubieScrollBound = true;

      let fired = false;

      el.addEventListener("scroll", () => {
        const horizontal = el.scrollWidth > el.clientWidth;
        const vertical = el.scrollHeight > el.clientHeight;

        let percent = 0;

        if (horizontal) {
          percent = Math.round(
            (el.scrollLeft / (el.scrollWidth - el.clientWidth)) * 100
          );
        } else if (vertical) {
          percent = Math.round(
            (el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100
          );
        }

        if (!fired && percent > 10) {
          fired = true;

          this.log("Scroll >10% fired", {
            ...params,
            percent_scrolled: percent,
            direction: horizontal ? "horizontal" : "vertical"
          });

          this.send({
            ...params,
            extra: {
              ...(params.extra || {}),
              percent_scrolled: percent,
              direction: horizontal ? "horizontal" : "vertical"
            }
          });
        }
      });
    });
  },

  /* -----------------------------
     IMPRESSION TRACKING
  ------------------------------ */
  bindImpressions() {
    this.log("Binding impression tracking...");

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;

          const el = entry.target;
          const params = this.parse(el);
          if (!params || params.action !== "impression") return;

          this.log("Impression fired:", params);

          this.send(params);
          observer.unobserve(el);
        });
      },
      { threshold: 0.3 }
    );

    document.querySelectorAll("[data-track]").forEach(el => {
      const params = this.parse(el);
      if (params && params.action === "impression") {
        observer.observe(el);
      }
    });
  },

  /* -----------------------------
     JSON PARSER
  ------------------------------ */
  parse(el) {
    try {
      return JSON.parse(el.getAttribute("data-track"));
    } catch {
      this.log("Invalid JSON in data-track:", el);
      return null;
    }
  }
};

/* ============================================================
   INITIALIZE + SHOPIFY EVENTS
============================================================ */

const init = () => CubieTrack.init();

[
  "DOMContentLoaded",
  "shopify:section:load",
  "shopify:section:select",
  "shopify:section:deselect"
].forEach(evt => document.addEventListener(evt, init));
